document.addEventListener('DOMContentLoaded', function () {
  var DISCLAIMER_TEXT = (window.chatStrings && window.chatStrings.disclaimer) || '';
  var BANNER_ID = 'chat-ai-disclaimer';

  if (!DISCLAIMER_TEXT) return;

  function injectBanner(header) {
    var root = header.getRootNode();
    if (root.getElementById(BANNER_ID)) return;

    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.textContent = DISCLAIMER_TEXT;
    banner.style.cssText =
      'padding: 8px 16px;' +
      'font-size: 12px;' +
      'line-height: 1.4;' +
      'text-align: center;' +
      'color: var(--shopify-agent-text-color, #666);' +
      'background: rgba(0, 0, 0, 0.04);' +
      'border-bottom: 1px solid rgba(0, 0, 0, 0.08);';

    header.insertAdjacentElement('afterend', banner);
  }

  function tryInject() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return;

    var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
    if (!runtime || !runtime.shadowRoot) return;

    var header = runtime.shadowRoot.querySelector('.panel__header');
    if (!header) return;

    injectBanner(header);
  }

  var interval = setInterval(tryInject, 1000);
  window.addEventListener('beforeunload', function () {
    clearInterval(interval);
  });
});
